import { useMemo } from 'react';
import { useAtomValue } from 'jotai';

import { getPreInterview } from '../pre-interview';
import { getApplyJobStatusDataAtom } from './application-details.context';

/**
 * The interview with Serena for the application on screen, or `undefined` when it has none.
 *
 * The single place the detail page asks about the interview. It reads the two fields the
 * application itself carries — `assessment_channel` and `assessment_status` — so an
 * application whose interview is not in the app draws the page exactly as it did before the
 * interview existed.
 */
export const usePreInterview = () => {
  const applyJobStatusData = useAtomValue(getApplyJobStatusDataAtom);

  return useMemo(() => getPreInterview(applyJobStatusData), [applyJobStatusData]);
};
